import { http } from './http'

export const getOfferCatalogs = () => {
  return http().get('/api/offer_catalogs')
}
